/** Small numeric helpers shared by the world, the input and the camera. */

export const clamp = (x: number, lo: number, hi: number): number => (x < lo ? lo : x > hi ? hi : x);

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

/** Frame-rate independent smoothing: moves `x` towards `target` with rate `k` per second. */
export const approach = (x: number, target: number, k: number, dt: number): number =>
  x + (target - x) * (1 - Math.exp(-k * dt));

/** 0 below `a`, 1 above `b`, a smooth ramp in between. */
export function smoothstep(a: number, b: number, x: number): number {
  const t = clamp((x - a) / (b - a), 0, 1);
  return t * t * (3 - 2 * t);
}

/** Ease in and out, for walks: slow at both ends. */
export const easeInOut = (p: number): number =>
  p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;

/** Overshoots a little before settling, for things that pop into place. */
export function easeBack(p: number): number {
  const c1 = 1.70158;
  const c3 = c1 + 1;
  return 1 + c3 * Math.pow(p - 1, 3) + c1 * Math.pow(p - 1, 2);
}

/** The prototype's deterministic hash in [0, 1): the same tile always gets the same flowers. */
export function hash2(a: number, b: number): number {
  let h = Math.imul(a ^ 0x9e3779b9, 0x85ebca6b) ^ Math.imul((b + 0x632be5ab) | 0, 0xc2b2ae35);
  h ^= h >>> 16;
  h = Math.imul(h, 0x7feb352d);
  h ^= h >>> 15;
  h = Math.imul(h, 0x846ca68b);
  h ^= h >>> 16;
  return (h >>> 0) / 4294967296;
}

/** Rounds to 4 decimals, the precision presence and walk messages use. */
export const r4 = (x: number): number => Math.round(x * 1e4) / 1e4;
